import { cn } from "../lib/cn";

/**
 * Stylised falcon-in-shield mark used as a neutral stand-in for the federal emblem.
 * The official UAE emblem is a protected mark and must be supplied by the Ministry.
 */
export function Emblem({ className, size = 40 }: { className?: string; size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" className={cn("shrink-0", className)} aria-hidden>
      <defs>
        <linearGradient id="emblem-gold" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#dabc70" />
          <stop offset="1" stopColor="#755a21" />
        </linearGradient>
      </defs>
      <path d="M32 3 L56 12 V32 C56 46 45 56 32 61 C19 56 8 46 8 32 V12 Z" fill="url(#emblem-gold)" />
      <path d="M32 9 L50 16 V32 C50 42 42 50 32 54 C22 50 14 42 14 32 V16 Z" fill="none" stroke="#fdfcfa" strokeOpacity="0.6" strokeWidth="1.5" />
      <path d="M32 18 C26 18 22 23 22 28 C22 34 27 38 32 44 C37 38 42 34 42 28 C42 23 38 18 32 18 Z M32 24 C34.5 24 36 26 36 28 C36 30.5 34 33 32 36 C30 33 28 30.5 28 28 C28 26 29.5 24 32 24 Z" fill="#fdfcfa" />
      <path d="M20 30 L14 27 M44 30 L50 27" stroke="#fdfcfa" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}
